module.exports = __webpack_public_path__ + "media/images/ac_templates/201/gryht-4bc1a500de587bc87b7a31b5176fe8e3.jpg";